import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@core/shared';
import { LeaderboardComponent } from './leaderboard.component';
import { SelectPartnerLeaderboardComponent } from './component/selectpartner/selectpartner.component';
import { ThreemcarcareLeaderboardComponent } from './component/threemcarcare/threemcarcare.component';
import { LeaderboardService } from './services/leaderboard.services';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [
        LeaderboardComponent,
        SelectPartnerLeaderboardComponent,
        ThreemcarcareLeaderboardComponent
    ],
    providers: [
        LeaderboardService
    ]
})
export class LeaderboardModule { }
